module.exports = __webpack_public_path__ + "static/media/ispo-lft-shape.430372b3.svg";